import { Card, CardContent, Box, Typography, Grid, Divider } from '@mui/material';
import { AdminServiceStatus } from '../../../../types/admin';
import StatusIndicator from '../shared/StatusIndicator';
import { formatNumber, formatPercentage } from '../../../../utils/formatters';

interface ServiceStatusCardProps {
  service: AdminServiceStatus;
}

export default function ServiceStatusCard({ service }: ServiceStatusCardProps) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        {/* Header: Service Name + Status */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" sx={{ flex: 1 }}>
            {service.service}
          </Typography>
          <StatusIndicator status={service.status} size="small" />
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {service.description}
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* Metrics Grid */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Uptime (24h)
            </Typography>
            <Typography variant="h6" sx={{ color: service.uptime_24h > 99.5 ? '#2e7d32' : '#ed6c02' }}>
              {formatPercentage(service.uptime_24h, 2)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Response Time (p95)
            </Typography>
            <Typography variant="h6">{service.response_time_p95}ms</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Error Rate
            </Typography>
            <Typography variant="h6" sx={{ color: service.error_rate > 1 ? '#d32f2f' : '#2e7d32' }}>
              {formatPercentage(service.error_rate, 2)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Request Rate
            </Typography>
            <Typography variant="h6">{formatNumber(service.request_rate)}/min</Typography>
          </Grid>
        </Grid>

        {/* Last Incident */}
        {service.last_incident && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography variant="caption" color="error">
                Last Incident: {service.last_incident}
              </Typography>
              {service.last_incident_date && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {service.last_incident_date}
                </Typography>
              )}
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
}
